import API from "./API";
import { sessionRenewApi } from "./sessionRenewApi";

export const equipmentInfo = async (payload) => {
  try {
    return await API.post("/sems/system_status", payload);
  } catch (error) {
     if (error.response && error.response.status === 403) {
      await sessionRenewApi();
      return API.post("/sems/system_status", payload);
    }
    throw error;
  }
};
